import React from 'react';
import { Switch, Route } from 'react-router';
import { useSelector } from 'react-redux';
import BillingPage from '../../billing/BillingPage';
import { selectCurrentUser } from '../../../store/modules/users/selectors';
import ProfileTopTabs from '../ProfileTopTabs';
import PaymentMethodPage from '../../billing/PaymentMethodPage';
import InvoicesPage from '../../billing/InvoicesPage';
import CreditHistoryPage from '../../billing/CreditHistoryPage';

const BillingTab = () => {
  const user = useSelector(selectCurrentUser);

  return (
    <>
      <ProfileTopTabs loading={user.loading} tabResource="profileBilling" />
      <Switch>
        <Route path="/dashboard/profile/billing/plan">
          <BillingPage user={user} />
        </Route>
        <Route path="/dashboard/profile/billing/payment-method">
          <PaymentMethodPage user={user} />
        </Route>
        <Route path="/dashboard/profile/billing/invoices">
          {user.data && <InvoicesPage user={user.data} />}
        </Route>
        <Route path="/dashboard/profile/billing/credit-history">
          {user.data && <CreditHistoryPage user={user.data} />}
        </Route>
      </Switch>
    </>
  );
};

export default BillingTab;
